import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom'

import DomainTechnologies from '../../components/domainTechnologies.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {AdvertisersPageResult} from '../../../../server/routes/website.js'

interface WebsiteAdvertisersProps {
	server: string;
	pageData: unknown;
}

export default function WebsiteAdvertisers({server, pageData}: WebsiteAdvertisersProps) {

	let [data, setData] = useState(pageData as AdvertisersPageResult);

    // TODO: all that code below is the same for /website/* pages ... create a component out of it
    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
				<DomainTechnologies 
					technologies={data.Technologies}
				/>    
            </div>
        </section>
    </>)
}
